import { useMemo } from 'react';

import type { I18nFn } from 'i18n/types/I18nFn';
import type { SearchFacet } from 'modules/search/types/SearchFacet';
import type { SearchType } from 'modules/search/types/SearchType';

import { useSearchFacetsEvent } from './useSearchFacetsEvent';
import { useSearchFacetsInternship } from './useSearchFacetsInternship';
import { useSearchFacetsJob } from './useSearchFacetsJob';
import { useSearchFacetsOrg } from './useSearchFacetsOrg';
import { useSearchFacetsVolop } from './useSearchFacetsVolop';

/**
 * Do not import this on public pages, as it causes all facets to be included in the bundle
 */
export function useSearchFacetsByType(i18n: I18nFn) {
  const { jobSearchFacets } = useSearchFacetsJob(i18n);
  const { internshipSearchFacets } = useSearchFacetsInternship(i18n);
  const { volopSearchFacets } = useSearchFacetsVolop(i18n);
  const { eventSearchFacets } = useSearchFacetsEvent(i18n);
  const { orgSearchFacets } = useSearchFacetsOrg(i18n);

  return useMemo(
    () =>
      ({
        JOB: jobSearchFacets,
        INTERNSHIP: internshipSearchFacets,
        VOLOP: volopSearchFacets,
        EVENT: eventSearchFacets,
        ORG: orgSearchFacets,
      }) satisfies Record<SearchType, SearchFacet[]>,
    [
      eventSearchFacets,
      internshipSearchFacets,
      jobSearchFacets,
      orgSearchFacets,
      volopSearchFacets,
    ],
  );
}
